import React, { FC } from 'react';
import { Skeleton, Stack } from '@mui/material';
import { DashboardCard } from '@monorepo/nova-ui';

export const WinLossRateCardSkeleton: FC = () => {
  return (
    <DashboardCard sx={{ width: '100%' }}>
      <Stack sx={{ width: '100%' }} spacing={2} alignItems="center">
        {/* Title */}
        <Skeleton
          variant="text"
          width="60%"
          height={20}
          sx={{ alignSelf: 'flex-start' }}
        />

        {/* Gauge skeleton - semi-circular */}
        <Skeleton
          variant="rectangular"
          width={120}
          height={60}
          sx={{
            borderRadius: '60px 60px 0 0',
            my: 2,
          }}
        />

        {/* Win/Loss labels and values */}
        <Stack
          direction="row"
          justifyContent="space-between"
          width="100%"
          sx={{ mt: 2 }}
        >
          {/* Win Rate */}
          <Stack alignItems="center">
            <Skeleton variant="text" width={40} height={24} />
            <Skeleton variant="text" width={60} height={16} />
          </Stack>

          {/* Loss Rate */}
          <Stack alignItems="center">
            <Skeleton variant="text" width={40} height={24} />
            <Skeleton variant="text" width={60} height={16} />
          </Stack>
        </Stack>
      </Stack>
    </DashboardCard>
  );
};
